export { default, useDefaultProps } from './DefaultPropsProvider';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/DefaultPropsProvider/index.js
// module id = 849
// module chunks = 25